import React from 'react';
export function PanoramaxPreviewCard({
  formattedDate,
  linkUrl,
  thumbnailUrl
}) {
  const title = formattedDate ? `Panoramax - ${formattedDate}` : 'Panoramax';
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      color: 'primary',
      fontSize: '12px',
      marginBottom: '4px'
    }
  }, title), /*#__PURE__*/React.createElement("a", {
    href: linkUrl,
    rel: "noreferrer",
    style: {
      display: 'block'
    },
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Panoramax",
    src: thumbnailUrl,
    style: {
      width: '100%',
      borderRadius: '8px',
      border: '1px solid #e0e0e0',
      display: 'block'
    }
  })));
}